import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { P } from "../Text/P.js";
import { popupHeaderVariants } from "./PopupHeader.variants.js";
const PopupHeader_Description_PopupHeaderDescription = /*#__PURE__*/ forwardRef(function({ className, children, ...props }, ref) {
    const { description } = popupHeaderVariants();
    return /*#__PURE__*/ jsx(P, {
        ref: ref,
        className: cn(description(), className),
        ...props,
        children: children
    });
});
PopupHeader_Description_PopupHeaderDescription.displayName = "PopupHeader.Description";
export { PopupHeader_Description_PopupHeaderDescription as PopupHeaderDescription };
